<template>
    <div
    class="bg-white border border-border rounded-md hidden mb-4 lg:block">
    <h6 class="card-title p-4 border-b border-border !m-0"> Information Regarding Dependent Coverage</h6>
    <div class="p-4">
      <div class="mb-5">
        <p class="content">
        Once you enroll and your membership is activated, you will be able to add spouse/domestic partner and/or
              dependents if your policy provides for the additional coverage. You may do this by registering on the
              Member Portal. Instructions will be included in your Welcome Letter that you will receive after
              activation.
              <br>
              <br><b class="text-black">Please note</b>, if you are enrolling in an individual only plan, your
              dependents will not be eligible for coverage.
              </p>
      </div>
    </div>
  </div>
  <div class="bg-white border border-border rounded-md hidden lg:block">
    <h6 class="card-title p-4 border-b border-border !m-0">
      Disclaimer
    </h6>
    <div class="p-4">
      <div  v-if="
      state.enrollment_settings.disclaimer_text != '' &&
      state.enrollment_settings.disclaimer_text != null" class="content" id="viewer"></div>
    </div>
  </div>
</template>

<script>


export default {
  name: "PolicyInfo",
  props: {
    state: {
      type: Object,
    },
  }
};
</script>

<style scoped>
/* Add component-specific styles here if needed */
</style>
